'use strict';

var App = require('app');
var AppState = require('app_state');
var i18n = require('utils/i18n');
var Misc = require('utils/misc');
var Values = require('models/values');
var Notification = require('utils/notification');
var MultiselectFilter = require('components/common/templates/multiselect_filter');

var SelectValuesInputView = Marionette.ItemView.extend({
    template: require('components/common/templates/select_values_input'),

    events: {
        'click button#js-save': 'saveClicked',
        'input .search-input': 'updateSearchInput',
        'change #js-update-class': 'switchUpdateClass',
    },

    sortElements: function (e1, e2) {
        // case insensitive comparison -> convert to upper case
        var name1 = i18n.DATAPOINT(e1.group, e1.name).toUpperCase();
        var name2 = i18n.DATAPOINT(e2.group, e2.name).toUpperCase();

        return name1 > name2 ? 1 : name2 > name1 ? -1 : 0;
    },

    createUniqueID: function (val) {
        return escape(
            [
                val.name,
                val.type,
                val.nr,
                val.length,
                val.min,
                val.max,
                val.unit,
                val.format,
                val.is_readonly,
                val.is_unit_fixed || false,
                val.display_unit,
            ].join('_')
        );
    },

    initialize: function (options) {
        var allowedValues = this.options.AllowedValueTypes;
        if (options.selectedValues.models) {
            if (allowedValues.length > 0) {
                options.selectedValues.models = options.selectedValues.models.filter(function (e) {
                    return allowedValues.includes(e.attributes.type);
                });
            }
            _.each(
                options.selectedValues.models,
                function (m) {
                    m.set('uniqueId', this.createUniqueID(m.attributes));
                },
                this
            );
        }
        this.options = options || {};

        this.createSelectionArray(options.selectedValues.toJSON());
        this.optionsLookupTable = {};
        _.each(
            this.options.options,
            function (e) {
                _.each(
                    e.values,
                    function (v) {
                        v.uniqueId = this.createUniqueID(v);
                        this.optionsLookupTable[v.uniqueId] = v;
                    },
                    this
                );
            },
            this
        );

        var hasModels = options.selectedValues.models && options.selectedValues.models.length > 0;
        // skip this check for configuration dialog,
        // since we are only selecting values to display and not their configuration
        if (hasModels && options.selectedValues.models[0].get('type') && this.options.useCustomValues) {
            _.each(
                options.selectedValues.models,
                function (m) {
                    if (this.optionsLookupTable[m.get('uniqueId')]) {
                        return; // same value found in all_value_specs -> nothing to do
                    }
                    // not found in all_value_specs -> was customized
                    var type = m.get('type') === 'MBR' ? 0 : 1;
                    var opt = this.options.options[type].values;

                    if (m.get('spec') > 0) {
                        // customized value has reference to value_specs -> get default value and override with custom value
                        var idx = _.findIndex(opt, { value_ref: 'vs_' + m.get('spec') });
                        // should not happen
                        if (idx === -1) {
                            return;
                        }
                        var el = opt[idx];
                        delete this.optionsLookupTable[el.uniqueId]; // delete key
                        m.set('update_class', el.update_class); // keep default update_class

                        // override default register
                        el = m.toJSON();
                        this.optionsLookupTable[el.uniqueId] = el;
                        opt[idx] = el;
                        return;
                    }

                    // value not found in all_value_specs_view -> should actually not happen!
                    this.optionsLookupTable[m.get('uniqueId')] = m.toJSON();
                    opt.push(m.toJSON());
                },
                this
            );
        }

        _.each(
            this.options.options,
            function (e) {
                e.values.sort(this.sortElements);
            },
            this
        );

        this.noValueSpecsAvailable = _.size(this.optionsLookupTable) == 0;
        this.selectedClass = 0;
        this.searchInput = '';
    },

    serializeData: function () {
        return {
            showExtendedInfos: AppState.user.get('is_expert'),
            noValueSpecsAvailable: this.noValueSpecsAvailable,
            hideInfo: this.noValueSpecsAvailable || !this.options.showUpdateClassInfo,
            multi: this.options.multi,
            options: this.options.options,
            selectedValues: this.selection[this.selectedClass],
            updateClass: this.selectedClass,
            deviceID: this.options.deviceID,
            showNoValuesMessage: this.options.options[0].name === undefined,
            noValuesMessage: this.options.noValuesMessage || i18n.TR('Momentan sind keine Werte verfügbar.'),
        };
    },

    updateSearchInput: function (e) {
        this.searchInput = e.currentTarget.value;
    },

    getValueByID: function (id) {
        // return deepcopy of the original element
        return JSON.parse(JSON.stringify(this.optionsLookupTable[id]));
    },

    switchUpdateClass: function (e) {
        this.updateSelection();
        this.selectedClass = parseInt(e.currentTarget.value);
        $('#value-multi-select')[0].innerHTML = '';
        this.render();
    },

    createSelectionArray: function (allSelectedValues) {
        this.selection = [
            _.filter(allSelectedValues, function (e) {
                return e.update_class !== undefined;
            }),
        ]; // all values except for "empty" values
        for (var i = 1; i <= 3; i++) {
            this.selection[i] = _.where(allSelectedValues, { update_class: i });
        }
    },

    updateSelection: function () {
        var e, element;
        var allValues = [];
        var self = this;
        var selection = $('#value-multi-select').val() || [];

        if (self.selectedClass === 0) {
            _.forEach(selection, function (entry) {
                //get properties
                e = self.getValueByID(entry);
                // was element already selected?
                element = _.find(self.selection[0], { name: e.name, type: e.type, nr: e.nr, length: e.length });
                if (element) {
                    e.update_class = element.update_class;
                }
                allValues.push(e);
            });
        } else {
            for (var i = 1; i <= 3; i++) {
                if (i !== this.selectedClass) {
                    allValues = allValues.concat(this.selection[i]);
                }
            }
            //add values with unspecified update_class
            allValues = allValues.concat(_.where(this.selection[0], { update_class: 0 }));

            _.forEach(selection, function (entry) {
                //get properties
                e = self.getValueByID(entry);
                element = _.find(allValues, { uniqueId: e.uniqueId });
                if (element) {
                    // was already contained in another update_class -> change class
                    element.update_class = self.selectedClass;
                } else {
                    e.update_class = self.selectedClass;
                    allValues.push(e);
                }
            });
        }
        this.createSelectionArray(allValues);
    },

    getChanges: function () {
        this.updateSelection();
        var self = this;

        var element, idx, model;
        var deleted = [];
        var added = [];
        var changed = [];

        _.forEach(self.selection[0], function (e) {
            // get reference to original values
            idx = _.findIndex(self.options.selectedValues.toJSON(), { uniqueId: e.uniqueId });

            // was added?
            if (idx < 0) {
                var valSpec = self.getValueByID(self.createUniqueID(e));
                //add value_specs ID for values from value_specs table
                e.id = valSpec.value_ref.startsWith('v') ? valSpec.value_ref.split('_')[1] : 0;
                added.push(Values.fromSpec(self.options.deviceID, e));
                return;
            }

            // was changed? -> take original value and only change the update class
            model = self.options.selectedValues.models[idx];
            if (model.get('update_class') != e.update_class) {
                model.set('update_class', e.update_class);
                changed.push(model);
            }
        });

        _.forEach(self.options.selectedValues.models, function (model) {
            var e = model.toJSON();
            if (e.update_class === undefined) {
                return;
            }
            element = _.find(self.selection[0], { uniqueId: e.uniqueId });

            // element _not_ in current selection? -> was deleted!
            if (!element) {
                deleted.push(model);
            }
        });

        return {
            deleted: deleted,
            added: added,
            changed: changed,
        };
    },

    changesOk: function (changes) {
        // make sure registers used for smart temp are not being deleted
        if (this.options.smartTemp) {
            var protectedValues = this.options.smartTemp.getProtectedValues(true);
            for (var i = 0; i < protectedValues.length; i++) {
                var reg = protectedValues[i];
                if (
                    _.find(changes.deleted, function (model) {
                        return model.getAddress() === reg;
                    }) ||
                    _.find(changes.changed, function (model) {
                        return model.getAddress() === reg && model.get('update_class') > 2;
                    })
                ) {
                    Notification.show(
                        'error',
                        i18n.TR('Fehler'),
                        i18n.TR(
                            'Wertauswahl konnte nicht aktualisiert werden, da Register von Smart Temp verwendet wird.'
                        )
                    );
                    return false;
                }
            }
        }
        return true;
    },

    onAttach: function () {
        this.initializeMultiSelect();
    },

    onRender: function () {
        this.initializeMultiSelect();
        this.initializeSelectPicker();
        $('.modal-dialog').addClass('modal-lg');
    },

    onShow: function () {
        this.initializeSelectPicker();
    },

    onBeforeDestroy: function () {
        $('.modal-dialog').removeClass('modal-lg');
    },

    initializeMultiSelect: function () {
        initializeValueMultiSelect(
            '#value-multi-select',
            i18n.TR('Verfügbar'),
            i18n.TR('Ausgewählt') + (this.options.multi ? ' (' + i18n.TR('Schnittmenge') + ')' : ''),
            this.updateClasses,
            this.searchInput,
            this.options.showUpdateClassDropdown
        );
    },

    initializeSelectPicker: function () {
        Misc.initSelectPicker();
        $('button[data-id=js-update-class]').addClass('btn-white form-control search-input m-t-10');
        $('#js-update-class').val(this.selectedClass);
        $('button[data-id=js-update-class]>span.filter-option').text(this.updateClasses[this.selectedClass]);
    },

    updateClasses: [
        i18n.TR('alle Werte'),
        i18n.TR('Aktualisierungsklasse') + ' 1',
        i18n.TR('Aktualisierungsklasse') + ' 2',
        i18n.TR('Aktualisierungsklasse') + ' 3',
    ],
});

var SelectValuesDialogView = Marionette.LayoutView.extend({
    template: require('components/common/templates/select_values_dialog'),

    regions: {
        selectValuesInputRegion: '#selectValuesInput',
    },

    events: {
        'click button#js-save': 'saveClicked',
    },

    saveClicked: function (e) {
        e.preventDefault();
        var changes = this.selectValuesInputView.getChanges();
        if (this.selectValuesInputView.changesOk(changes)) {
            App.hideModal();
            var view = this.selectValuesInputView;
            this.options.update_cb(changes, view.selection[view.selectedClass]);
        }
    },

    onShow: function () {
        this.selectValuesInputView = new SelectValuesInputView(this.options);
        this.showChildView('selectValuesInputRegion', this.selectValuesInputView);
    },
});

var initializeValueMultiSelect = function (elem, selectable, selected, classes, searchString, showUpdateClassDropdown) {
    var multiSelectConfig = {
        selectableHeader: '<span class="font-600">' + selectable + '</span>',
        selectionHeader: '<span class="font-600">' + selected + '</span>',
    };

    // add search input field + update class dropdown
    var searchBoxSelectableHtml = MultiselectFilter({
        placeholder: i18n.TR('Suche...'),
        value: searchString || '',
        id: 'ct-selectable',
    });
    var dropdownSelectedHtml =
        '<select id="js-update-class" name="js-update-class" class="selectpicker" data-style="btn-white">';
    _.forEach(classes, function (e, i) {
        dropdownSelectedHtml += '<option value="' + i + '">' + e + '</option>';
    });
    dropdownSelectedHtml += '</select>';
    if (!showUpdateClassDropdown) {
        dropdownSelectedHtml = MultiselectFilter({
            placeholder: i18n.TR('Suche...'),
            value: searchString || '',
            id: 'ct-selected',
        });
    }

    multiSelectConfig.selectableHeader += searchBoxSelectableHtml;
    multiSelectConfig.selectionHeader += dropdownSelectedHtml;

    // add methods
    multiSelectConfig.afterInit = function (ms) {
        var self = this;
        var $selectableSearch = self.$selectableUl.prev();
        var selectableSearchString = '#' + self.$container.attr('id') + ' .ms-elem-selectable:not(.ms-selected)';

        self.qs1 = $selectableSearch.quicksearch(selectableSearchString).on('keydown', function (e) {
            if (e.which === 40) {
                self.$selectableUl.focus();
                return false;
            }
        });

        if (!showUpdateClassDropdown) {
            var $selectionSearch = self.$selectionUl.prev();
            var selectionSearchString = '#' + self.$container.attr('id') + ' .ms-elem-selection.ms-selected';
            self.qs1 = $selectionSearch.quicksearch(selectionSearchString).on('keydown', function (e) {
                if (e.which === 40) {
                    self.$selectionUl.focus();
                    return false;
                }
            });
        }
    };
    multiSelectConfig.afterSelect = function () {
        this.qs1.cache();
    };
    multiSelectConfig.afterDeselect = function () {
        this.qs1.cache();
    };

    $(elem).multiSelect(multiSelectConfig);
};

module.exports = {
    Input: SelectValuesInputView,
    Dialog: SelectValuesDialogView,
};
